var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footer"},[_c('div',{staticClass:"Wrapper"},[_vm._v(" 遠時數位科技股份有限公司為遠傳電信集團關係企業 / 版權所有 copyright © 2017 YSDT. All Rights Reserved. "),_c('div',{staticClass:"GoContect"},[_c('a',{attrs:{"href":"https://shopping.friday.tw/interact/CustomerService.do?method=init","target":"_blank","title":"聯絡我們"}},[_vm._v("聯絡我們")])])])])
}]

export { render, staticRenderFns }